import { createFileRoute } from "@tanstack/react-router";
import { RouteGuard } from "@/components/RouteGuard";
import { DialogueCharacterManagement } from "@/lib/lazyPages";

export const Route = createFileRoute("/admin/dialogue-characters")({
  component: () => (
    <RouteGuard access={{ kind: "admin" }}>
      <DialogueCharacterManagement />
    </RouteGuard>
  ),
});
